import { Tooltip as DirectTooltip, type TooltipProps as DirectTooltipProps } from '@direct-frontend/components'; // eslint-disable-line no-restricted-imports -- Разрешаем импортировать Tooltip

export type TooltipProps = Omit<DirectTooltipProps, 'autoFocusProps'>;

const AUTO_FOCUS_PROPS = {
    contain: false,
    autoFocus: false,
    restoreFocus: false,
} as const;

/*
  Дефолтные autoFocusProps в библиотеке захватывают фокус, из-за чего открытый тултип блокирует
  взаимодействие с другими элементами и не закрывается при клике вне его.
*/
export const Tooltip = (props: TooltipProps) => <DirectTooltip {...props} autoFocusProps={AUTO_FOCUS_PROPS} />;
